$('document').ready(function () {
    // Width
    var width = window.innerWidth || document.body.clientWidth;

    // Fade in / fade out page transition
    setTimeout(function () {
        $('body').addClass('render');
    }, 60);

    $('.site--fade').on('click', function (e) {
        if ($(this).attr('target') != '_blank') {
            e.preventDefault();
            if ($(this).attr("href").indexOf("#") == -1) {
                var url = $(this).attr('href');
                $('body').removeClass('render');
                setTimeout(function () {
                    window.location = url;
                }, 350);
            }
        }
    });

    // Check touch devices
    var checkMobile = function () {
        var isTouch = ('ontouchstart' in document.documentElement);
        if (isTouch) {
            $('html').addClass('touch');
        }
        else {
            $('html').addClass('no-touch');
        }
    };
    checkMobile();

    // Tap events zepto
    $('.card-header').on('touchstart', function () {
        $(this).addClass('active-state');
    });
    $('.card-header').on('touchend', function () {
        $(this).removeClass('active-state');
    });

    // Scroll to
    /* Au clic sur un lien et scroll sur une autre page */
    if (window.location.hash) {
        $('html, body').css('opacity', '0');
        setTimeout(function () {
            $('html, body').scrollTop(0).show();
            $('html, body').css('opacity', '1');
            $('html, body').animate({
                scrollTop: $(window.location.hash).offset().top
            }, 1200, 'easeInOutExpo')
        }, 700);
    }
    
    // Scroll top
    $('.scroll-top').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({scrollTop: 0}, 1200, 'easeInOutExpo');
    });

    // Mmenu
    if ($('#responsive-menu').length > 0) {
        var $menu = $('#responsive-menu').mmenu({
            navbar: {
                add: true,
                title: 'Menu'
            },
            navbars: [{
                position: 'top'
            }],
            'extensions': [
                'position-right'
            ]
        }, {
            offCanvas: {
                pageSelector: "#main-content"
            }
        });

        var $mmenuIcon = $('.burger-nav-button');
        var $mmenuAPI = $menu.data("mmenu");

        $mmenuIcon.on('click', function () {
            if ($('html').hasClass('mm-wrapper_opened')) {
                $mmenuAPI.close();
            } else {
                $mmenuAPI.open();
            }
        });

        $mmenuAPI.bind('open:start', function () {
            $mmenuIcon.addClass('is-active');
        });
        $mmenuAPI.bind('close:start', function () {
            $mmenuIcon.removeClass('is-active');
        });
    }

    $('.textimg .media-image img').each(function () {
        var img = $(this);
        var width = img.width();
        var height = img.height();
        var aspectratio = (height / width) * 100;
        $(this).parents('.media-image').find('.image-aspect-ratio').css('padding-top', aspectratio + '%');
    });

    // Widget weather
    if ($('.btn-weather').length > 0) {
        $.ajax({
            type: "GET",
            url: "https://api.openweathermap.org/data/2.5/weather?q=Luxembourg,LU&units=metric&appid=08ab2cc9066cda84f867361619691ceb&mode=xml",
            dataType: "xml",
            success: function (xml) {
                //console.log(xml);
                $(xml).find('current').each(function () {
                    var icon = $(this).find('weather').attr('icon');
                    var temperature = $(this).find('temperature');
                    $('.btn-weather .item-weather').append("" +
                        "<img src='/themes/hotel-cravat/images/weather/" + icon + ".png' />" +
                        "<span class='data-value'>" + parseInt($(temperature).attr('value')) + "&deg;c</span>"
                    );
                });
            }
        });
        $.ajax({
            type: "GET",
            url: "https://api.openweathermap.org/data/2.5/forecast/daily?q=Luxembourg,LU&units=metric&appid=08ab2cc9066cda84f867361619691ceb&mode=xml&cnt=5",
            dataType: "xml",
            success: function (xml) {
                //console.log(xml);
                $(xml).find('weatherdata').each(function () {
                    var day = $(this).find('forecast time');

                    $('.table-weather .weather-day').each(function (i) {
                        var currentDay = day[i];
                        var icon = $(currentDay).find('symbol').attr('var');
                        var temperature = $(currentDay).find('temperature');

                        $(this).find('.day-icon').append("" +
                            "<img src='/themes/hotel-cravat/images/weather/" + icon + "_grey" + ".png' />"
                        );
                        $(this).find('.temperature-min').append("" +
                            "<span class='data-value'>" + parseInt($(temperature).attr('min')) + "&deg;c</span>"
                        );
                        $(this).find('.temperature-max').append("" +
                            "<span class='data-value'>" + parseInt($(temperature).attr('max')) + "&deg;c</span>"
                        );
                    });
                });
            }
        });
    }
});

// Validation form BS4
(function () {
    'use strict';
    window.addEventListener('load', function () {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function (form) {
            form.addEventListener('submit', function (event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();